export default function initAccordion() {
  const accordionItems = document.querySelectorAll(
    ".accordion__left-list-item"
  );

  const rightImage = document.querySelector(".accordion__right-image");

  accordionItems.forEach((item) => {
    const content = item.querySelector(".accordion__left-list-item-content");
    const title = item.querySelector(".accordion__left-list-item-title");

    // Handle hover events for both accordion and image
    item.addEventListener("mouseenter", () => {
      // Close all other items
      accordionItems.forEach((otherItem) => {
        if (otherItem !== item) {
          const otherContent = otherItem.querySelector(
            ".accordion__left-list-item-content"
          );
          const otherTitle = otherItem.querySelector(
            ".accordion__left-list-item-title"
          );
          otherContent.classList.remove("active");
          otherTitle.classList.remove("active");
          otherItem.classList.add("faded");
        }
      });

      // Open current item
      content.classList.add("active");
      title.classList.add("active");

      // Change image
      const newImage = item.dataset.image;
      if (newImage) {
        rightImage.src = newImage;
      }
    });

    item.addEventListener("mouseleave", () => {
      // Remove fade from other items
      accordionItems.forEach((otherItem) => {
        otherItem.classList.remove("faded");
      });

      // Close current item
      content.classList.remove("active");
      title.classList.remove("active");

      // Reset image to default
      rightImage.src = defaultImage;
    });
  });
}
